import React from "react";
import { Grid, Chip, Badge, withStyles } from "@material-ui/core";
import { Clear } from "@material-ui/icons";
import { getLassoBadgeLabel } from "./utils";

const shipmentStyles = (theme) => ({
  badge: {
    fontSize: 11,
    height: 16,
    minWidth: 16,
    margin: 6,
    borderRadius: 8,
    zIndex: "inherit",
  },
  chipRoot: {
    fontSize: 11,
    margin: 2,
    height: 28,
    borderRadius: 5,
    backgroundColor: theme.lightPrimaryColor,
    color: theme.palette.primary.main,
    "&:focus": {
      backgroundColor: theme.lightPrimaryColor,
    },
  },
  chipDeleteIcon: {
    cursor: "pointer",
    paddingRight: 12,
  },
  shipmentListContainer: {
    padding: "8px 0px",
  },
  chipLabel: {
    paddingLeft: 0,
  },
});
let ShipmentList = (props) => {
  const { classes, customerShipments } = props;
  return (
    <div className={classes.shipmentListContainer}>
      {customerShipments &&
        Object.keys(customerShipments).map((customerId) => {
          const groupedCustomerCount = customerShipments[customerId].length;
          return (
            <Badge
              color="primary"
              badgeContent={groupedCustomerCount}
              classes={{ badge: classes.badge }}
              key={customerId}
              invisible={groupedCustomerCount < 2}
            >
              <Chip
                label={getLassoBadgeLabel(customerShipments[customerId][0])}
                classes={{
                  root: classes.chipRoot,
                  icon: classes.chipDeleteIcon,
                  label: classes.chipLabel,
                }}
                clickable={false}
                color="primary"
                icon={
                  <Clear onClick={() => props.onDeleteShipment(customerId)} />
                }
              />
            </Badge>
          );
        })}
    </div>
  );
};

const ShipmentProperties = ({ data }) => (
  <Grid container spacing={16}>
    {data.map((item, index) => (
      <React.Fragment key={index}>
        <Grid item xs={4}>
          {item.label}
        </Grid>
        <Grid item xs={2}>
          {item.value}
        </Grid>
      </React.Fragment>
    ))}
  </Grid>
);

ShipmentList = withStyles(shipmentStyles)(ShipmentList);
export { ShipmentList, ShipmentProperties };
